import { useTranslation } from "react-i18next";
import { addStorageObject } from "../../app/state/storageObjectSlice/actions/actions";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { NoObjectChosen } from "../../common/NoObjectChosen";
import { useAppDispatch } from "../../services/redux/hooks/use-dispatch";
import { ResizableWrapper } from "../../shared/components/ResizableWrapper";
import { EventLog } from "./Components/EventLog";
import { Result } from "./Components/Result";
import styles from "./styles.module.css";

interface Props {
  className?: string;
}

export const ResearchService = ({ className }: Props) => {
  const dispatch = useAppDispatch();
  const { selectedObject } = useStorageSelectors("research");
  const { t } = useTranslation();

  const handleAddResearchObject = () => {
    dispatch(
      addStorageObject({
        name: t("research.default_name"),
        service: "research",
        objectType: "child",
      }),
    ).unwrap();
  };

  if (selectedObject?.value === null) {
    return (
      <NoObjectChosen
        message={"Выберите или создайте объект исследования в "}
        folderName={selectedObject?.friendly_name}
        onClick={handleAddResearchObject}
      />
    );
  }

  return (
    <div className={styles.container}>
      <ResizableWrapper
        hasButton
        isCollapsible={"right"}
        leftBlock={<Result />}
        rightBlock={<EventLog />}
        leftBlockSize={70}
        rightBlockSize={30}
        leftBlockMinSize={70}
        leftClassName={styles["left-panel"]}
        rightClassName={styles["right-panel"]}
      />
    </div>
  );
};
